import { of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

import { DynamicallyEvaluated } from './types/personalized-content.type';

export const tryTakeDynamicExpression = <T>(
  source: DynamicallyEvaluated<T>,
  key: keyof T,
) => {
  const result$ = source.evaluationResult[key];
  if (!result$) {
    return of(source[key]);
  } else {
    return result$.pipe(
      startWith(null),
      map(val => (!Boolean(val) ? source[key] : val)),
    );
  }
};
